import AccordionList from "components/common/AccordionList";
import Progress from "components/common/Progress";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import React, { FC, useCallback } from "react";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { IGeneralSkill } from "types/lifeChoice";
import styles from "../index.module.scss";
import { t } from "i18next";

const GeneralSkills: FC = () => {
  const { lifeChoice } = useLifeChoicePageContext();
  const { dir, language } = useAppSelector(getSettings);

  const renderHeader = useCallback(
    ({ title, value }: IGeneralSkill) => (
      <>
        <h5 className="text-base">{title[language]}</h5>
        <Progress max={100} value={value} />
      </>
    ),
    [dir, language]
  );

  const renderBody = useCallback(
    ({ description }: IGeneralSkill) => <p>{description[language]}</p>,
    [dir, language]
  );

  return (
    <div
      className={`${styles["general-skills"]}`}
      dir={dir}
      lang={language}
    >
      <h4 className="text-lg font-semibold py-4" lang={language} dir={dir}>
        {t("requiredSkills") as string}
      </h4>
      <AccordionList
        items={(lifeChoice.general_skills as any).slice(0, 6).map((item: any) => ({...item.id, value: item.value}))}
        renderHeader={renderHeader}
        renderBody={renderBody}
        headerClassName={styles["accordion-header-custom"]}
      />
    </div>
  );
};

export default GeneralSkills;
